import { createTheme, ThemeProvider } from "@mui/material";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppProvider from "../context/app.context";
import { AuthProvider } from "../context/AuthContext";
import OrganizationProvider from "../context/organization.context";

import { AppRoutes as route } from "../constants/index";
import AppLayout from "../layout/AppLayout";
import AppProtectedLayout from "../layout/AppProtectedLayout";
import {
  DonationSummaryPage,
  ForgotPasswordPage,
  OrganizationLoginPage,
  PlatformLandingPage,
} from "../pages";
import {
  DonorLogin,
  PickCityPage,
  RegisterDonorPage,
} from "../pages/DonationPage";
import VerifyOtpPage from "../pages/DonationPage/donor-auth/verify-otp/VerifyOtpPage";
import CampaignNgoOrgPage from "../pages/DonationPage/ngo-org-page/CampaignNgoOrgPage";
import { AddEditMemberPage } from "../pages/MemberPage";
import { UserRole } from "../types";
import DynamicOrganizationRoutes from "./DynamicOrganizationRoutes";
import { AppRoutes } from "./route";

const Router = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#035DB8",
      },
      secondary: {
        main: "#ED8B00",
      },
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <AppProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route element={<AppLayout />}>
                  <Route
                    path={AppRoutes.ROOT}
                    element={<PlatformLandingPage />}
                  />
                  <Route
                    path={route.DONOR.DONATION}
                    element={<PickCityPage />}
                  />
                  {/* <Route
                    path="/members/add/:organizationId"
                    element={<AddEditMemberPage />}
                  /> */}
                  {/* <Route path={AppRoutes.DONATE} element={<NGOLandingPage />} /> */}
                  {/* <Route
                    path={AppRoutes.DONATE}
                    element={<NGODontationPage />}
                  /> */}
                  {/* <Route
                    path={AppRoutes.DONATE_NGOS}
                    element={<NgoListingPage />}
                  /> */}
                  <Route
                    path={route.DONOR.DONATION_NGO}
                    element={<CampaignNgoOrgPage />}
                  />
                  <Route
                    path={AppRoutes.DONATE_SUMMARY}
                    element={<DonationSummaryPage />}
                  />
                </Route>

                {/* Auth Routes */}
                <Route
                  path={AppRoutes.ORG_LOGIN}
                  element={<OrganizationLoginPage />}
                />
                <Route
                  path={AppRoutes.DONOR_LOGIN}
                  element={<DonorLogin userType={UserRole.DONOR} />}
                />
                {/* <Route
                  path={AppRoutes.DONOR_REGISTER}
                  element={<RegisterDonorPage userType={UserRole.DONOR} />}
                /> */}
                <Route
                  path={route.DONOR.DONOR_VERIFY}
                  element={<VerifyOtpPage />}
                />

                <Route
                  path={AppRoutes.ORG_FORGOT_PASSWORD}
                  element={<ForgotPasswordPage />}
                />
                {/* <Route path="/reset-password" element={<ResetPasswordPage />} /> */}

                {/* All Protected Routes -*/}
                <Route
                  path={AppRoutes.ORG_BASE}
                  // element={
                  //   <OrganizationProvider>
                  //     <OrganizationLayout>
                  //       <DynamicOrganizationRoutes />
                  //     </OrganizationLayout>
                  //   </OrganizationProvider>
                  // }
                  element={
                    <OrganizationProvider>
                      <AppProtectedLayout>
                        <DynamicOrganizationRoutes />
                      </AppProtectedLayout>
                    </OrganizationProvider>
                  }
                />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
          <Toaster />
        </AppProvider>
      </ThemeProvider>
    </>
  );
};

export default Router;
